export const ROLE_COORDINATOR = 'coordinator'
export const ROLE_OSDA = 'osda'
export const ROLE_HEAD_OF_GROUP = 'hog'
export const ROLE_ADVISOR = 'advisor'

export const PROJECT_STATUS_TEXT = {
  Draft: 'แบบร่าง',
  WaitingForHeadOfProjectApproval: 'อยู่ระหว่างการพิจารณาจากประธานโครงการ',
  WaitingForHeadOfGroupApproval: 'อยู่ระหว่างการพิจารณาจากประธานหน่วยงาน',
  WaitingForAdvisorApproval: 'อยู่ระหว่างการพิจารณาจากที่ปรึกษาหน่วยงาน',
  WaitingForStudentCouncilApproval: 'อยู่ระหว่างการพิจารณาของสโมสรนักศึกษา',
  WaitingForFacultyStaff: 'อยู่ระหว่างการพิจารณาจากเจ้าหน้าที่กิจการนักศึกษาคณะ',
  WaitingForFacultyDean: 'อยู่ระหว่างการพิจารณาจากจากผู้ช่วย/รองคณบดี',
  WaitingForCouncilApproval: 'อยู่ระหว่างการพิจารณาจากสภานักศึกษา (งบสำรองจ่าย)',
  WaitingForOsdaApproval: 'อยู่ระหว่างการพิจารณาจากสำนักงานกิจการนักศึกษา',
  Approved: 'สำนักงานกิจการนักศึกษาอนุมัติจัดโครงการ',
  AwaitingForClosureApproval: 'อยู่ระหว่างการพิจารณาปิดโครงการจากสำนักงานกิจการนักศึกษา',
  Closed: 'ปิดโครงการ',
  AdvisorRejected: 'ที่ปรึกษาหน่วยงานไม่อนุมัติ',
  OsdaRejected: 'สำนักงานกิจการนักศึกษาไม่อนุมัติจัดโครงการ',
  DraftForCloseProjectApproval: 'ร่างคำขอปิดโครงการ',
  WaitingFotHeadOfProjectCloseProjectApproval: 'อยู่ระหว่างการพิจารณาปิดของประธานโครงการ',
  WaitingForHeadOfGroupCloseProjectApproval: 'อยู่ระหว่างการพิจารณาปิดของประธานหน่วยงาน',
  WaitingForAdvisorCloseProjectApproval: 'อยู่ระหว่างการพิจารณาปิดของที่ปรึกษาหน่วยงาน',
  WaitingForStudentCouncilCloseProjectApproval: 'อยู่ระหว่างการพิจารณาปิดของสโมสรนักศึกษา',
  WaitingForFacultyStaffCloseProjectApproval: 'อยู่ระหว่างการพิจารณาปิดของเจ้าหน้าที่กิจการนักศึกษาคณะ',
  WaitingForFacultyDeanCloseProjectApproval: 'อยู่ระหว่างการพิจารณาปิดของผู้ช่วย/รองคณบดี'
}

export const USER_ROLE_TEXT = {
  Coordinator: 'ผู้ประสานงาน',
  Osda: 'เจ้าหน้าที่กิจการนักศึกษา',
  HeadOfGroup: 'ประธานหน่วยงาน',
  Advisor: 'ที่ปรึกษาหน่วยงาน'
}

export const ROLE_SUFFIX_BY_GROUP_TYPE = {
  Association: 'สโมสร',
  Club: 'ชมรม',
  Group: 'ชุมนุม',
  StudentCouncil: 'สโมสรนักศึกษา',
  StudentUnion: 'องค์การนักศึกษา',
  PeopleGroup: 'กลุ่ม',
  Council: 'สภา'
}

export const ROLE_SUFFIX_BY_GROUP_TYPE_CODE = {
  1: 'สโมสร',
  2: 'ชมรม',
  3: 'ชุมนุม',
  4: 'สโมสร',
  5: 'องค์การ',
  6: 'กลุ่ม',
  7: 'สภา'
}

export const PROJECT_CHANGE_REQUEST_STATUS_TEXT = {
  Pending: 'รอพิจารณา',
  Approved: 'อนุมัติ',
  Rejected: 'ไม่อนุมัติ'
}
